export const BASE_URL = 'https://pro-municipalidad.clinia.com.ar:9123/support_api/v1';
export const BASE_URL_SOCKET = 'https://pro-municipalidad.clinia.com.ar:9123';